import { Image } from "react-bootstrap";
import MainLayout from "../components/MainLayout";

import { useTranslation } from 'react-i18next';

const UsPage = () => {
  const { t } = useTranslation();
  const us = t('us');

  return (
    <MainLayout>
      <About {...us.manifest} />
      <Team {...us.team} />
    </MainLayout>
  );
};

const About = ({ title, description }) => {
  return (
    <div className="container about-us-container">
      <p className="fs-48 fw-bold d-xl-none text-white text-center mb-4">
        {title}
      </p>
      <div className="row row-cols-1 rwo-cols-lg-2 d-flex align-items-center g-0">
        <div className="col col-xl-5">
          <div className="d-flex justify-content-center pb-4 pb-xl-0">
            <div className="bg-opacity about-us-card-image d-flex mx-3 mx-xl-0">
              <Image
                className="img-fluid"
                style={{ objectFit: "cover", borderRadius: "15px" }}
                src={`${process.env.PUBLIC_URL}/images/us/manifest.jpg`}
                alt="loading..."
              />
            </div>
          </div>
        </div>
        <div className="col col-xl-7">
          <div className="text-white mx-3 mx-md-5 mx-lg-0">
            <div className=" about-us-manifest-container">
              <p className="d-none d-xl-block fs-30 fw-bold text-center">{title}</p>
              <p className="fs-16 fw-light lh-25 text-justify-responsive">
                {description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Team = ({ title, subtitle, members }) => {
  return (
    <div>
      <div className="container py-5">
        <h1 className="text-center fw-bold fs-48 text-white">{title}</h1>
        <div className="row my-5">
          <div className="d-none d-md-block col-2"></div>
          {
            members.map((member, index) => (
              <div key={index} className="col-12 col-md-4">
                <div className="card mb-4">
                  <div className="card-body">
                    <img src={`${process.env.PUBLIC_URL}/images/us/${member.imgURL}`}
                      alt="loading..."
                      className="card-img-top mb-2"
                    />
                    <h5 className="card-title text-center blue-quantico">{member.name}</h5>
                    <h6 className="card-subtitle mb-2 text-muted text-center">{member.position}</h6>
                    <div className="d-flex">
                      <a className="text-center mx-auto zoom-in blue-linkedin" href={`${member.linkedinURL}`} target="_blank" rel="noreferrer">
                        <i className="fab fa-linkedin fs-36"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))
          }
          <div className="d-none d-md-block col-2"></div>
        </div>
      </div>
    </div>
  )
}

export default UsPage;
